import { RadioGroup, RadioItem, Stack } from 'braid-design-system';
import { Controller, useFormContext } from 'react-hook-form';

import type { FormValues } from 'src/pages/manage/security-breach/SecurityBreach';

import { atLeastOne } from '../validation';

export const SeekData = () => {
  const { watch } = useFormContext<FormValues>();
  const seekData = watch('seekData');
  const seekCredentials = watch('seekCredentials');
  const seekFault = watch('seekFault');
  return (
    <Stack space="small">
      <Controller
        name="seekData"
        rules={{
          validate: atLeastOne('Select Yes or No.'),
        }}
        render={({ field, fieldState }) => (
          <RadioGroup
            id="security-breach-seek-data"
            label="Are you aware of SEEK data (e.g. hirer details, candidate details, your SEEK integration credentials) being exposed to unintended third parties?"
            message={fieldState.error?.message}
            value={field.value}
            onChange={({ currentTarget: { value } }) =>
              field.onChange(value as 'Yes' | 'No')
            }
          >
            <RadioItem
              label="Yes"
              value="Yes"
              data={{ id: 'security-breach-seek-data-yes' }}
            />
            <RadioItem
              label="No"
              value="No"
              data={{ id: 'security-breach-seek-data-no' }}
            />
          </RadioGroup>
        )}
      />
      {(seekData === 'Yes' ||
        seekCredentials === 'Yes' ||
        seekFault === 'Yes') && (
        <Stack space="small">
          <Controller
            name="seekCredentials"
            rules={{
              validate: atLeastOne('Select Yes or No.'),
            }}
            render={({ field, fieldState }) => (
              <RadioGroup
                id="security-breach-seek-credentials"
                label="Were SEEK credentials exposed?"
                value={field.value}
                message={fieldState.error?.message}
                onChange={({ currentTarget: { value } }) =>
                  field.onChange(value as 'Yes' | 'No')
                }
              >
                <RadioItem
                  label="Yes"
                  value="Yes"
                  data={{ id: 'security-breach-seek-credentials-yes' }}
                />
                <RadioItem
                  label="No"
                  value="No"
                  data={{ id: 'security-breach-seek-credentials-no' }}
                />
              </RadioGroup>
            )}
          />
          <Controller
            name="seekFault"
            rules={{
              validate: atLeastOne('Select Yes or No.'),
            }}
            render={({ field, fieldState }) => (
              <RadioGroup
                id="security-breach-seek-fault"
                label="Does the fault lie with SEEK?"
                value={field.value}
                message={fieldState.error?.message}
                onChange={({ currentTarget: { value } }) =>
                  field.onChange(value as 'Yes' | 'No')
                }
              >
                <RadioItem
                  label="Yes"
                  value="Yes"
                  data={{ id: 'security-breach-seek-fault-yes' }}
                />
                <RadioItem
                  label="No"
                  value="No"
                  data={{ id: 'security-breach-seek-fault-no' }}
                />
              </RadioGroup>
            )}
          />
        </Stack>
      )}
    </Stack>
  );
};
